import React from 'react';
import styles from './App.module.css';
import Grain from './components/Grain';
import SystemBar from './components/SystemBar';
import Wall from './components/Wall';
import Tile from './components/Tile';
import Hero from './components/Hero';
import Footer from './components/Footer';

function App() {
  return (
    <>
      <Grain />
      <div className={styles.frame}>
        <SystemBar />
        <Wall>
          {/* OAKCLIFF.TECH hero — span 4, surface tone */}
          <Tile span={4} className={styles.heroSpan}>
            <Hero />
          </Tile>

          {/* Coming Soon — span 2, ochre */}
          <Tile span={2} tone="ochre" label="Status" glyph="◆">
            <div className={styles.slab}>
              Coming<br />Soon
              <small className={styles.slabSmall}>Site under construction</small>
            </div>
          </Tile>

          {/* 01 / The Community — span 3 */}
          <Tile span={3} label="01 / The Community" glyph="▸">
            <p className={styles.copy}>
              A community for the{' '}
              <b>designers, developers, engineers, and founders</b>{' '}
              building in Oak&nbsp;Cliff — connecting the local tech scene, one introduction at a time.
            </p>
          </Tile>

          {/* 02 / What's Coming — span 3 */}
          <Tile span={3} label="02 / What's Coming" glyph="▸">
            <div className={styles.list}>
              <div className={styles.listItem}>
                <b>Meetups</b>
                <span>Regular gatherings to share work and learn.</span>
              </div>
              <div className={styles.listItem}>
                <b>Connections</b>
                <span>Meet the people building near you.</span>
              </div>
              <div className={styles.listItem}>
                <b>Events</b>
                <span>Talks, demos, and community nights.</span>
              </div>
            </div>
          </Tile>

          {/* 03 / Coordinates — span 3 */}
          <Tile span={3} label="03 / Coordinates" glyph="▸">
            <div className={styles.coords}>
              <div><span className={styles.coordKey}>Established</span>MMXXVI</div>
              <div><span className={styles.coordKey}>Locus</span>32.74°N 96.83°W</div>
              <div><span className={styles.coordKey}>County</span>Dallas, TX</div>
              <div><span className={styles.coordKey}>District</span>Oak Cliff</div>
            </div>
          </Tile>

          {/* 04 / First Meeting — span 3, ink */}
          <Tile span={3} tone="ink" label="04 / First Meeting" glyph="◆">
            <div className={styles.meetBig}>
              To Be<br />Announced
            </div>
            <div className={styles.meetSub}>Date &amp; venue soon</div>
          </Tile>
        </Wall>
        <Footer />
      </div>
    </>
  );
}

export default App;
